module.exports = __webpack_public_path__ + "din.28f7aec451cfeba3de64.woff";


//////////////////
// WEBPACK FOOTER
// A:/Work/Siti/Volpe2/src/app/themes/default/css/fonts/din.woff
// module id = ../../../../../src/app/themes/default/css/fonts/din.woff
// module chunks = 1